/**
 *  get iframe inner Height setup data attr to iframe element
 *     <iframe src="https://stundenplan.bbw.ch/bms/" data-iframe-height="true"></iframe>
 *     need to access by cross origin frame
 * @type {any}
 */

let iframe = {

    init: () => {

        iframe.name = 'iframe';
        iframe.elements = document.querySelectorAll(iframe.name);
        iframe.attemptActionIfNotEmpty(iframe.ready);

        window.addEventListener('load', () => {
            iframe.attemptActionIfNotEmpty(iframe.loaded);
        });

        return iframe;
    },

    attemptActionIfNotEmpty: function (action) {
        if (iframe.elements.length > 0) {
            action();
        }
    },

    ready: () => {

        iframe.elements.forEach((element) => {
            element.addEventListener('load', (event) => {
                if (element.dataset.iframeHeight) {
                    iframe.setHeight(element);
                }
            });
        });

    },

    setHeight: (element) => {
        element.style.height = element.contentWindow.document.body.scrollHeight + 'px';
    },

    loaded: () => {

    }

};

export default iframe.init();
